import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="w-full px-5 py-14 sm:px-8" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-15">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 text-center" data-id="element-16">
        <Logo width={150} height={50} data-id="element-17" />
        <p className="font-heading text-lg font-light italic" style={{
        color: 'var(--darkgoldenrod)'
      }} data-id="element-18">
          Su Nombre es Amor
        </p>
        <p className="max-w-md text-sm leading-relaxed" style={{
        color: 'rgba(42,36,32,0.6)'
      }} data-id="element-19">
          Retiro Espiritual en Bali · 10 — 17 de octubre de 2026 · Ubud,
          Indonesia
        </p>

        <div className="w-full max-w-3xl border-t pt-6 text-left" style={{
        borderColor: 'rgba(42,36,32,0.1)'
      }} data-id="element-20">
          <p className="text-center text-xs font-medium uppercase tracking-[0.18em]" style={{
          color: 'rgba(42,36,32,0.58)'
        }} data-id="element-21">
            Información importante
          </p>
          <p className="mt-3 text-center text-xs leading-relaxed" style={{
          color: 'rgba(42,36,32,0.55)'
        }} data-id="element-22">
            Las imágenes y fotografías de esta página son de apoyo e inspiración
            visual; no representan necesariamente los lugares, alojamientos,
            actividades o experiencias específicos que harán parte del retiro.
            El itinerario, los proveedores y los detalles de la experiencia se
            confirmarán antes de la inscripción y podrán ajustarse por
            condiciones locales, meteorológicas, operativas o de seguridad,
            manteniendo siempre el propósito y la calidad de la experiencia.
          </p>
          <p className="mt-3 text-center text-xs leading-relaxed" style={{
          color: 'rgba(42,36,32,0.55)'
        }} data-id="element-23">
            Al compartir tus datos o solicitar información, aceptas el
            tratamiento conforme a nuestra{' '}
            <a href="https://espacioparaelalma.com/politica-privacidad/" target="_blank" rel="noreferrer" className="underline underline-offset-2 transition-opacity hover:opacity-70" style={{
            color: 'var(--darkgoldenrod)'
          }} data-id="element-24">
              Política de tratamiento de datos personales
            </a>
            .
          </p>
        </div>

        <p className="text-xs" style={{
        color: 'rgba(42,36,32,0.45)'
      }} data-id="element-25">
          © {new Date().getFullYear()} Espacio para el Alma. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}